import Icons from '../../../common/widgets/Icons';
import {
  getAutocompleteSuggestionSubtitle,
  getAutocompleteSuggestionTitle,
} from '../helpers/autocompleteHelper';

import { AutocompleteSuggestionItem } from '../models/Search';

interface SearchSuggestionItemProps {
  suggestion: AutocompleteSuggestionItem;
  index: number;
  focused: boolean;
  highlightedTitle: string;
  onClick: (suggestion: AutocompleteSuggestionItem, index: number) => void;
}

const SearchSuggestionItem = ({
  suggestion,
  index,
  focused,
  highlightedTitle,
  onClick,
}: SearchSuggestionItemProps) => {
  const title = getAutocompleteSuggestionTitle(suggestion);
  const subtitle = getAutocompleteSuggestionSubtitle(suggestion);
  return (
    <li
      className={`suggestion-item ${focused ? 'focused-suggestion' : ''}`}
      key={`${suggestion.type}-${title}-${index}`}
    >
      <button
        type="button"
        className={`fake-search-suggestions-btn`}
        onClick={() => onClick(suggestion, index + 1)}
      >
        {suggestion.type === 'product' && (
          <span className="search-suggestion-icon">
            <Icons.SearchList />
          </span>
        )}

        {suggestion.type === 'category' && (
          <span className="search-suggestion-icon">
            <Icons.Dashboard />
          </span>
        )}

        {suggestion.type === 'brand' && (
          <span className="search-suggestion-icon">
            <Icons.Tag />
          </span>
        )}

        <div className="search-suggestion-content">
          <div
            className="search-suggestion-title"
            dangerouslySetInnerHTML={{
              __html: highlightedTitle,
            }}
          />

          {subtitle && (
            <div className="search-suggestion-subtitle">{subtitle}</div>
          )}
        </div>
      </button>
    </li>
  );
};

export default SearchSuggestionItem;
